const Reflux = require("reflux");
const ListingActions = require("app/shared/actions/listing-actions");
const cx = require("classnames");
const _ = require("underscore");

const ListingFilterDropdownProducts = React.createClass({
  propTypes: {
    data: React.PropTypes.object.isRequired,
    className: React.PropTypes.string,
    label: React.PropTypes.string.isRequired
  },

  getInitialState: function() {
    return ({ isListLoaded: false, matchingProducts: [] });
  },

  componentDidMount: function(){
    this.focusSearchInputOnOpen();
    this.preventDropdownCloseOnClick();

    ListingActions.loadProducts();
  },

  componentWillReceiveProps: function(nextProps) {
    let newList = nextProps.data.pro.data;

    if (!this.state.isListLoaded && Array.isArray(newList)) {
      this.setState({ isListLoaded: true, matchingProducts: newList });
    }
  },

  focusSearchInputOnOpen: function() {
    $(this.refs.dropdown).on("shown.bs.dropdown", () => {
      if (this.refs.input) {
        this.refs.input.focus();
      }
    });
  },

  preventDropdownCloseOnClick: function() {
    $(this.refs.dropdown).on("hide.bs.dropdown", () => {
      return !$(this.refs["dropdown-menu"]).is(":hover");
    });
  },

  getList: function() {
    return this.props.data.pro.data;
  },

  handleClick: function(_event, product) {
    let filterName = this.getFilterName(product);
    let selectedProducts = this.selectedProducts();

    if (this.isProductSelected(product)) {
      ListingActions.removeFilter({
        name: filterName
      }, false);

      selectedProducts.splice(selectedProducts.indexOf(product.id), 1);
    } else {
      ListingActions.applyFilter({
        name: filterName,
        value: 1,
        label: product.name
      }, false);

      selectedProducts.push(product.id);
    }

    if (selectedProducts.length > 0) {
      ListingActions.applyFilter({
        name: "pro",
        value: selectedProducts.join(),
        label: "Products",
        filterLabel: "produtos",
        hide: true,
        data: this.getList()
      });
    } else {
      ListingActions.removeFilter({ name: "pro" });
    }
  },

  selectedProducts: function() {
    let entries = _.pick(this.props.data, (filterValue, filterName) => (
      filterName.startsWith("pro")
        && filterName.length > 3
        && filterValue.value === 1
    ));

    return Object.keys(entries).map(filterName => filterName.substr(3));
  },

  isProductSelected: function(product) {
    var filterName = this.getFilterName(product);

    return this.props.data[filterName] && this.props.data[filterName].value === 1;
  },

  getFilterName: function(product) {
    return "pro" + product.id;
  },

  handleInput: function(event) {
    let term = event.target.value.toLowerCase();
    let allProducts = this.getList();

    let matchingProducts = term === ""
      ? allProducts
      : allProducts.filter(product => product.name.toLowerCase().includes(term));

    this.setState({ matchingProducts });
  },

  renderTags: function() {
    if (this.state.matchingProducts.length === 0) {
      return (
        <span className="text-muted small">
          Nenhum produto encontrado
        </span>
      );
    } else {
      return this.state.matchingProducts.map((product) => {
        let tagClasses = cx("tag", "cuP", "mr5", "mb5",
          this.getFilterName(product), {
          "green": this.isProductSelected(product)
        });

        return (
          <span
            key={product.id}
            className={tagClasses}
            onClick={(event) => this.handleClick(event, product)}>
            <span>{product.name}</span>
          </span>
        );
      });
    }
  },

  render: function(){
    let buttonClasses = cx("pr-20", {
      "dropdown-toggle": true,
      "highlighted": this.props.data.pro.highlight
    });

    return (
      <div ref="dropdown" className={cx("dropdown", this.props.className)}>
        <button className={buttonClasses} type="button" data-toggle="dropdown">
          <div className="ovf-h">
            {this.props.label}
          </div>
          <span className="caret p-a custom-glyphicon icon-chevron-down"></span>
        </button>
        <div className="dropdown-menu w-380 mah-300 ovy-auto thinScrollbar" role="menu" ref="dropdown-menu">
          {
            !this.state.isListLoaded
              ? <span className="text-muted small">Carregando produtos...</span>
              : (
                <div>
                  <div className="mb10">
                    <input
                      ref="input"
                      type="text"
                      className="form-control input-sm w-100pct"
                      placeholder="Digite para filtrar"
                      autoComplete="off"
                      autofocus="true"
                      onChange={this.handleInput}
                    />
                  </div>

                  <div>
                    {this.renderTags()}
                  </div>
                </div>
              )
          }
        </div>
      </div>
    );
  }
});

module.exports = ListingFilterDropdownProducts;



// WEBPACK FOOTER //
// ./app/shared/components/List/listing-filter-dropdown-products.jsx